var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"bottom-footer"},[_c('el-col',{attrs:{"span":12,"offset":6}},[_c('span',[_c('i',{staticClass:"fa fa-copyright"}),_vm._v(" 召必回车服 | 联系 "),_c('a',{attrs:{"href":"tel:19922129951"}},[_vm._v("19922129951")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39290562","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BottomFooter.vue
// module id = null
// module chunks = 